export const SHOW_REGISTRATION_EXPIRED = 'SHOW_REGISTRATION_EXPIRED';

export const registrationIsInvalid = set => {
    return dispatch => {
        dispatch({ 
            type: SHOW_REGISTRATION_EXPIRED,
            set
        })
    }
}